export class MaintenanceModeError extends Error {
  constructor(message = "Request blocked due to maintenance mode") {
    super(message);
    this.name = "MaintenanceModeError";
  }
}
